/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hour: NonNullable<unknown>, minute: NonNullable<unknown> }} Event_State_Claim_PeriodInputs */

const en_event_state_claim_period = /** @type {(inputs: Event_State_Claim_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`claim ends in ${i?.hour}h ${i?.minute}m`)
};

const ar_event_state_claim_period = /** @type {(inputs: Event_State_Claim_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ينتهي الاستلام خلال ${i?.hour} س و ${i?.minute} د`)
};

const de_event_state_claim_period = /** @type {(inputs: Event_State_Claim_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abholung endet in ${i?.hour} Std. ${i?.minute} Min.`)
};

const es_event_state_claim_period = /** @type {(inputs: Event_State_Claim_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`la reclamación termina en ${i?.hour} h ${i?.minute} m`)
};

const fr_event_state_claim_period = /** @type {(inputs: Event_State_Claim_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`récupération se termine dans ${i?.hour} h ${i?.minute} min`)
};

const it_event_state_claim_period = /** @type {(inputs: Event_State_Claim_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`il riscatto termina tra ${i?.hour} o ${i?.minute} m`)
};

const ja_event_state_claim_period = /** @type {(inputs: Event_State_Claim_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`あと ${i?.hour}時間 ${i?.minute}分で受取終了`)
};

const ko_event_state_claim_period = /** @type {(inputs: Event_State_Claim_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`수령 종료까지 ${i?.hour}시간 ${i?.minute}분 남음`)
};

const pt_br_event_state_claim_period = /** @type {(inputs: Event_State_Claim_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`o resgate termina em ${i?.hour} h ${i?.minute} min`)
};

const ru_event_state_claim_period = /** @type {(inputs: Event_State_Claim_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`получение закончится через ${i?.hour} ч. ${i?.minute} мин.`)
};

const th_event_state_claim_period = /** @type {(inputs: Event_State_Claim_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`รับรางวัลได้ในอีก ${i?.hour} ชม. ${i?.minute} นาที`)
};

const tr_event_state_claim_period = /** @type {(inputs: Event_State_Claim_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ödül alımı ${i?.hour} sa ${i?.minute} dk içinde bitiyor`)
};

const zh_cn_event_state_claim_period = /** @type {(inputs: Event_State_Claim_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`还剩 ${i?.hour}时 ${i?.minute}分可领奖`)
};

const zh_tw_event_state_claim_period = /** @type {(inputs: Event_State_Claim_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`還剩 ${i?.hour}時 ${i?.minute}分可領獎`)
};

/**
* | output |
* | --- |
* | "claim ends in {hour}h {minute}m" |
*
* @param {Event_State_Claim_PeriodInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const event_state_claim_period = /** @type {((inputs: Event_State_Claim_PeriodInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_State_Claim_PeriodInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_state_claim_period(inputs)
	if (locale === "ar") return ar_event_state_claim_period(inputs)
	if (locale === "de") return de_event_state_claim_period(inputs)
	if (locale === "es") return es_event_state_claim_period(inputs)
	if (locale === "fr") return fr_event_state_claim_period(inputs)
	if (locale === "it") return it_event_state_claim_period(inputs)
	if (locale === "ja") return ja_event_state_claim_period(inputs)
	if (locale === "ko") return ko_event_state_claim_period(inputs)
	if (locale === "pt_br") return pt_br_event_state_claim_period(inputs)
	if (locale === "ru") return ru_event_state_claim_period(inputs)
	if (locale === "th") return th_event_state_claim_period(inputs)
	if (locale === "tr") return tr_event_state_claim_period(inputs)
	if (locale === "zh_cn") return zh_cn_event_state_claim_period(inputs)
	return zh_tw_event_state_claim_period(inputs)
});